/* eslint-disable react/prop-types */
import { Cancel, Check, Delete, Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  darken,
} from "@mui/material";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SelectCustomer from "components/SelectCustomer";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import useAuth from "hooks/useAuth";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { AlertState, DataTypeOwnerState } from "states";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_ROUTES, CODE_QUANGNAM } from "../../utils/constants";
import FormChuTheOCOP from "./formChuTheOCOP";
import DetailChuTheOCOP from "./detailChuTheOCOP";
import ViewChuTheOCOP from "./viewChuTheOCOP";
import LoadingCircle from "components/LoadingCircle/loadingCircle";
import InfoIcon from "@mui/icons-material/Info";
const ALLVALUE = { ma: "ALL", ten: "Tất cả" };
import {
  ID_GROUP_CHUTHE,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_SEVEN,
} from "../../utils/constants";

const dicGioiTinh = {
  M: "Nam",
  F: "Nữ",
  O: "Khác",
};

function ChuTheOCOP() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const { user } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const [alert, setAlert] = useRecoilState(AlertState);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [optionUser, setOptionUser] = useState([]);
  const optionLoaiHinh = useRecoilValue(DataTypeOwnerState);
  const [paramsState, setParamsState] = useState({
    maquan: ALLVALUE.ma,
    loaihinh: ALLVALUE.ma,
  });
  const [chuTheState, setChuTheState] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);
  const [detailState, setDetailState] = useState();
  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  const isOwner = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CHUTHE);
  }, [user]);
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);
  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);

  useEffect(() => {
    const fetchDataHuyen = async (codeProvince, maquan) => {
      try {
        let body = {
          tinh: codeProvince,
          huyen:
            (isHoiDong || isGroupNumberSeven) && maquan == ALLVALUE.ma
              ? user?.maquan
              : maquan,
        };
        const response = await axiosPrivateInstance.get(API_ROUTES.GETHUYEN, {
          params: body,
        });
        setOptionDistrict(response?.data);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataUser = async () => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.LISTUSER);
        setOptionUser(response?.data["data"]);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    if (!isOwner) {
      fetchDataUser();
      fetchDataHuyen(CODE_QUANGNAM, ALLVALUE.ma);
    }
  }, [isOwner]);

  const handleDelete = async () => {
    try {
      await axiosPrivateInstance.delete(
        API_ROUTES.QUANLYCHUTHE + "/" + selectedRow.id
      );
      // Remove the selected row from the data
      setTableData((prevData) =>
        prevData.filter((row) => row.id !== selectedRow.id)
      );
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = async (values) => {
    try {
      // setTableData([...tableData]);
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          API_ROUTES.QUANLYCHUTHE + "/" + values.id,
          { ...values }
        );
        let rowAdd = response.data;
        if (isOwner) {
          setChuTheState(rowAdd);
        } else {
          tableData[values.rowIndex] = rowAdd;
        }
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          API_ROUTES.QUANLYCHUTHE,
          {
            ...values,
          }
        );
        let rowAdd = response.data;
        tableData.unshift(rowAdd);
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      !isOwner && setTableData([...tableData]);
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = "";
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };

  // Lấy toàn bộ dữ liệu
  const fetchData = (
    { maquan, loaihinh },
    { pageIndex, pageSize },
    isOwner
  ) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    let body = {
      maquan:
        (isHoiDong || isGroupNumberSeven) && maquan == ALLVALUE.ma
          ? user?.maquan
          : maquan,
      loaihinh: isOwner || loaihinh == ALLVALUE.ma ? undefined : loaihinh,
      pageNumber: pageIndex + 1,
      countNumber: pageSize,
      username: isOwner ? user?.username : undefined,
    };
    axiosPrivateInstance
      .get(API_ROUTES.QUANLYCHUTHE, {
        params: body,
      })
      .then((res) => {
        if (isOwner) {
          const ID_CHUTHE = res.data?.data?.[0]?.id;
          if (ID_CHUTHE) {
            axiosPrivateInstance
              .get(API_ROUTES.QUANLYCHUTHE + "/" + ID_CHUTHE)
              .then((dataRes) => {
                let detail = { ...dataRes.data };
                detail["gioitinh_ten"] = dicGioiTinh?.[detail?.gioitinh] || "";
                setChuTheState(detail);
              });
          }
        } else {
          setRowCount(res.data?.totalRecord);
          setTableData(res.data?.data);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
        return;
      })
      .finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  };

  useEffect(() => {
    fetchData(paramsState, pagination, isOwner);
  }, [paramsState, pagination, isOwner]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "ma",
        header: "Mã",
        size: 120,
      },
      {
        accessorKey: "ten",
        header: "Chủ thể",
        size: 150,
      },
      {
        accessorKey: "ngaycap",
        header: "Ngày cấp",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value)?.isValid()
            ? dayjs(value)?.format("DD/MM/YYYY")
            : value;
        },
      },
      {
        accessorKey: "diachi",
        header: "Địa chỉ",
        size: 150,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 150,
      },
    ],
    []
  );

  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.QUANLYCHUTHE + "/" + id
      );
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa chủ thể OCOP");
    setValidationErrors({});
    setModalOpen(true);
  };
  const handleToClickEditDetail = async () => {
    const id = chuTheState?.id;
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.QUANLYCHUTHE + "/" + id
      );
      setDataRow({ ...response.data, rowIndex: new Date().getTime() });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa chủ thể OCOP");
    setValidationErrors({});
    setModalOpen(true);
  };
  const handleToCloseDetail = () => {
    setOpenDetail(false);
    setDetailState(null);
  };
  const handleToClickDetail = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.QUANLYCHUTHE + "/" + id
      );
      let detail = { ...response.data };
      detail["ngaycap"] = dayjs(detail["ngaycap"]).isValid()
        ? dayjs(detail["ngaycap"]).format("DD/MM/YYYY")
        : format(new Date(dayjs(detail["ngaycap"])), "dd/MM/yyyy");
      detail["ngaycap_cccd"] = dayjs(detail["ngaycap_cccd"]).isValid()
        ? dayjs(detail["ngaycap_cccd"]).format("DD/MM/YYYY")
        : null;
      detail["ngaysinh"] = dayjs(detail["ngaysinh"]).isValid()
        ? dayjs(detail["ngaysinh"]).format("DD/MM/YYYY")
        : null;
      setDetailState(detail);
      setOpenDetail(true);
    } catch (error) {
      console.log(error);
      return;
    }
  };
  const handleChangeSelectValue = (key) => (e, value) => {
    setParamsState((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const fieldInforChuThe = useMemo(() => {
    const result = [
      {
        key: "ma",
        name: "Mã/số đăng ký kinh doanh",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Tên chủ thể",
        key: "ten",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Tỉnh thành",
        key: "matinh_ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Quận/Huyện",
        key: "maquan_ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Phường/Xã",
        key: "maphuong_ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Địa chỉ",
        key: "diachi",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Email",
        key: "email",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số điện thoại",
        key: "dienthoai",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Loại hình tổ chức",
        key: "loaihinh_ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày cấp",
        key: "ngaycap",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Cơ quan cấp",
        key: "coquancap",
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        name: "Tài khoản người dùng",
        key: "username",
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        name: "Trạng thái",
        key: "trangthai_ten",

        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số lao động quản lý",
        key: "solaodongquanly",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Số lao động sản xuất",
        key: "solaodongsanxuat",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Ghi chú",
        key: "ghichu",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Người đại diện pháp luật",
        key: "nguoidaidienphapluat",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Email người đại diện",
        key: "nguoidaidienphapluat_email",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Địa chỉ người đại diện",
        key: "nguoidaidienphapluat_diachi",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Số điện thoại người đại diện",
        key: "nguoidaidienphapluat_dienthoai",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Chức vụ",
        key: "nguoidaidienphapluat_chucvu",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Giới tính",
        key: "gioitinh_ten",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Quốc gia",
        key: "quocgia_ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Dân tộc",
        key: "dantoc_ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày sinh",
        key: "ngaysinh",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số CCCD/Hộ chiếu",
        key: "socccd",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày cấp",
        key: "ngaycap_cccd",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Nơi cấp",
        key: "noicap_cccd",
        xs: 12,
        md: 4,
        lg: 4,
      },
    ];
    return result;
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isOwner ? (
        isLoading ? (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingCircle />
          </Box>
        ) : (
          <DetailChuTheOCOP
            data={chuTheState}
            fieldInfor={fieldInforChuThe}
            onEdit={handleToClickEditDetail}
          />
        )
      ) : (
        <>
          <MDBox
            pt={6}
            py={3}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              px: 3,
            }}
          >
            <Grid
              container
              spacing={2}
              rowSpacing={2}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12} md={4} lg={4}>
                <SelectCustomer
                  keyValue="maquan"
                  label="Quận/Huyện"
                  labelName="ten"
                  option={optionDistrict}
                  onChange={handleChangeSelectValue("maquan")}
                  state={paramsState.maquan}
                  unicode="ma"
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <SelectCustomer
                  keyValue="loaihinh"
                  label="Loại hình"
                  labelName="ten"
                  option={optionLoaiHinh}
                  onChange={handleChangeSelectValue("loaihinh")}
                  state={paramsState.loaihinh}
                  unicode="id"
                />
              </Grid>
            </Grid>
          </MDBox>
          <MDBox py={3}>
            <MaterialReactTable
              muiToolbarAlertBannerProps={
                isError
                  ? {
                      color: "error",
                      children: "Lỗi khi lấy dữ liệu",
                    }
                  : undefined
              }
              enableRowNumbers
              rowNumberMode="static"
              columns={columns}
              data={tableData}
              enableFilters={true}
              enableHiding={false}
              enableColumnOrdering={false}
              enableDensityToggle={true}
              enableColumnResizing
              enableGrouping
              enableEditing
              manualPagination
              onPaginationChange={setPagination}
              rowCount={rowCount}
              localization={MRT_Localization_VI}
              positionActionsColumn="last"
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  size: 105,
                },
              }}
              renderRowActions={({ row, table }) => (
                <Box sx={{ display: "flex" }}>
                  <Tooltip arrow placement="left" title="Chi tiết">
                    <IconButton
                      color="success"
                      onClick={() => handleToClickDetail(row)}
                    >
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                  {!isHoiDong ? (
                    <>
                      <Tooltip arrow placement="left" title="Chỉnh sửa">
                        <IconButton
                          color="info"
                          onClick={() => handelEditClick(row)}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                      <Tooltip arrow placement="right" title="Xoá">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            let _data = [];
                            _data["id"] = row.getValue("id");
                            _data["ten"] = row.getValue("ten");
                            handleOpenDeleteConfirmation(_data);
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </>
                  ) : (
                    <></>
                  )}
                </Box>
              )}
              renderTopToolbarCustomActions={() => (
                <Stack spacing={2} direction="row" color="white">
                  {!isHoiDong ? (
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      sx={{ color: "#ffffff" }}
                      onClick={() => {
                        setAction("New");
                        setTitle("Thêm mới chủ thể OCOP");
                        setDataRow({});
                        setValidationErrors({});
                        setModalOpen(true);
                      }}
                    >
                      Tạo mới
                    </Button>
                  ) : (
                    <></>
                  )}
                </Stack>
              )}
              initialState={{
                isLoading: true,
                columnVisibility: {
                  id: false,
                },
                density: "compact",
              }}
              state={{
                pagination,
                isLoading,
                showAlertBanner: isError,
                showProgressBars: isRefetching,
              }}
              muiTablePaperProps={{
                elevation: 0,
                sx: {
                  borderRadius: "0",
                  border: "1px solid rgb(211 225 245)",
                  backgroundColor: "#fff",
                },
              }}
              muiTableBodyProps={{
                sx: (theme) => ({
                  "& tr:nth-of-type(odd)": {
                    backgroundColor: darken(
                      theme.palette.background.default,
                      0.1
                    ),
                  },
                }),
              }}
            />
            <ViewChuTheOCOP
              data={detailState}
              open={openDetail}
              onClose={handleToCloseDetail}
              fieldInfor={fieldInforChuThe}
            />
            {/* Delete Confirmation Dialog */}
            <Dialog
              open={deleteConfirmationOpen}
              onClose={handleCloseDeleteConfirmation}
            >
              <DialogTitle>Xoá bảng ghi</DialogTitle>
              <DialogContent>
                <Typography>
                  Bạn muốn xoá chủ thể OCOP tên: {selectedRow?.ten}
                  không?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  color="secondary"
                  type="button"
                  variant="contained"
                  startIcon={<Cancel />}
                  size="small"
                  onClick={handleCloseDeleteConfirmation}
                  sx={{ color: "#ffffff", float: "right", mr: 1 }}
                >
                  Hủy
                </Button>
                <MDButton
                  color="primary"
                  onClick={handleDelete}
                  variant="contained"
                  startIcon={<Check />}
                  size="small"
                  sx={{ float: "right", mr: 1 }}
                >
                  Đồng ý
                </MDButton>
              </DialogActions>
            </Dialog>
          </MDBox>
        </>
      )}
      <FormChuTheOCOP
        data={dataRow}
        open={modalOpen}
        title={title}
        onClose={() => {
          setModalOpen(false);
          setValidationErrors({});
        }}
        onSubmit={handleSave}
        validationErrors={validationErrors}
        action={action}
        dataDistrictQN={optionDistrict}
        dataUser={optionUser}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default ChuTheOCOP;
